export default {
    common: {
        confirm: '确认',
        cancel: '取消',
        search: '搜索',
        submit: '提交',
        other: '其他',
        default: '默认',
        color_tag: '颜色标签',
        option: '选项',
        success: '成功',
        error: '错误',
        sending: '发送中',
        send_success: '发送成功',
        send_error: '发送失败',
        visits: '访问',
        table: '桌位',
        'one-way-message': '单向短信',
        'two-way-message': '双向短信',
        'one-way-voice': '单向语音',
        'two-way-voice': '双向语音',
        broadcast: '大屏幕广播',
        delete: '删除',
        delete_tip: '确定删除吗？',
        phone_number: '手机号码',
        name: '姓名',
    },
    setting: {
        setting: '设置',
        general: '通用',
        account: '账户',
        about: '关于',
        custom_language_label: '自定义语言',
        logo_label: '餐厅标志',
        name_label: '餐厅名称',
        version_label: '版本',
        privacy_label: '隐私声明',
        terms_label: '服务条款',
        logout_btn: '退出登录',
        logout_tip: '退出当前登录吗？'
    },
    rewards: {
        rewards: '福利',
        redeem: '兑换',
        used_time_label: '兑换时间',
        used: '已兑换',
        sure_to_redeem: '确定兑换',
        header_tip: '支持手机号模糊查询，可以直接使用手机号后4位',
    }
};